module.exports = __webpack_public_path__ + "static/media/Calcolodelpercorso.c667ac2d.svg";